import { Link } from "react-router-dom";

import { compactCents } from "../../utils/directorFormat";

// Aviso curto nas telas afetadas: há títulos fora da análise, com link para a lista.
const ExcludedTitlesNotice = ({ summary, companyId }) => {
  if (!summary?.count) return null;
  const parts = [
    summary.outflowCents > 0 ? `${compactCents(summary.outflowCents)} a pagar` : null,
    summary.inflowCents > 0 ? `${compactCents(summary.inflowCents)} a receber` : null,
  ].filter(Boolean);
  const query = companyId ? `?company_id=${encodeURIComponent(companyId)}` : "";
  return <p className="director-module1__callout director-excluded-titles" role="note" aria-label="Títulos retirados da análise">
    {summary.count === 1 ? "1 título retirado" : `${summary.count} títulos retirados`} da análise
    {parts.length ? ` (${parts.join(", ")})` : ""}.{" "}
    <Link to={`/dashboard/director/governance${query}`}>Ver lista</Link>
  </p>;
};

export default ExcludedTitlesNotice;
